import {
	Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector:			'electra-sub-page-header',
  styleUrls:		['./subPageHeader.component.scss'],
  templateUrl:	'./subPageHeader.component.html'
})
export class SubPageHeaderComponent {
	@Output() close	= new EventEmitter<any>();
  @Input()  text: string;
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/subPageHeader/subPageHeader.component.ts